import { withFormControl, InjectedInputProps } from './withFormControl';
import { Textarea, TextareaProps } from '@chakra-ui/react';

type TextareaFormControlProps = InjectedInputProps & TextareaProps;

export const TextareaFormControl = withFormControl((props: TextareaFormControlProps) => {
   return <Textarea bg="white" {...props} />;
});
